import React from 'react';
import PropTypes from 'prop-types';
import css from './NoSlotsFound.css';

export default class NoSlotsFound extends React.Component {

  get text() {
    return this.props.message ? this.props.message :
      "Sorry, we couldn't find any available appointments. " +
      "Please try again with a different date range.";
  }

  render() {
    return (
      <div className={css['container']}>
        {this.text}
      </div>
    );
  }
}

NoSlotsFound.propTypes = {
  message: PropTypes.string
};
